// /cart/1（配送方法の選択）で、#shippingdatetime_box_1 の先頭に出る「※お届け日はご指定いただけません」を消す。
// wuSiteResource2 の PackJapan/SiteCommon.ts の removeCart1Text() の引き取り先（Issue #58）。
// OPP本舗(3) の OppHonpo/SiteCommon.ts にも同じコードがあり、Issue #70 の 4 本目で足した（対象店は shared/hooks.ts の CART_SHIPPING_NOTE_SITES）。
//
// ★ 消すのはテキストノード（childNodes[0]）。querySelector では取れないので childNodes をそのまま見る。
// ★ ガードは旧実装のまま 1 つも省かない（要素が無い / 子が無い / 文言が違う → 何もしない）。
// 二度走っても、1 回目で消えていれば先頭の文言が一致しないので何もしない（過渡期に旧実装と重なっても害はない）。

export const SHIPPING_NOTE = '※お届け日はご指定いただけません'

/** 消したら true。 */
export function removeShippingNote(box: Element | null): boolean {
  if (box == null) return false
  if (box.childNodes.length < 1) return false
  const first = box.childNodes[0]
  if ((first.textContent ?? '').indexOf(SHIPPING_NOTE) === -1) return false
  first.parentNode?.removeChild(first)
  return true
}

export default function cartShippingNote(): void {
  removeShippingNote(document.getElementById('shippingdatetime_box_1'))
}
